export default {
  name: 'PrivacyPolicy',
  components: {}
};